var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNavMenu = function SvgNavMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 24,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 24,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 18,
    width: 24,
    height: 1,
    rx: 0.5
  }))));
};
export default SvgNavMenu;